<template>
  <div style="width:100%;">
    <div style="position: fixed;background-color: white;top: 0px;z-index: 999;width: 100%;">
      <div style="text-align:center">
        <van-button type="info" size="small" style="margin-left: 3%;width: 15%;" @click="goBack">返回</van-button>
        <screenButton class="screenButton"></screenButton>
      </div>
    </div>
    <div style="padding-top: 50px;" class="mater">
      <b-table striped small sticky-header sticky-header="calc(100vh - 50px)" head-variant="light" responsive bordered
               :items="items" :fields="fields" foot-clone>
        <template v-slot:head()="scope">
          <div class="text-nowrap" :style="{textAlign:'center'}">
            {{ scope.label }}
          </div>
        </template>
        <template v-slot:cell(index)="data">
          {{ data.index + 1 }}
        </template>
        <template v-slot:cell(materialData)="data" style="'left':'80px';">
          {{ data.item.materialName }}/{{ data.item.materialModel?data.item.materialModel:'-' }}/{{ data.item.materialUnit }}
        </template>
        <template v-slot:table-colgroup="scope">
          <col
              v-for="field in scope.fields"
              :key="field.key"
              :style="{ width: field.key === 'materialData' ? '140px' : field.key === 'index' ?'30px':'100px',left: field.key === 'materialData' ? '120px' : '80px'}"
          />
        </template>
        <template v-slot:foot()="scope">
          <div class="text-nowrap" :style="{textAlign:'center'}">-</div>
        </template>
        <template v-slot:foot(index)="data">
          <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">合计</div>
        </template>
        <template v-slot:foot(applyLeftNum)="data">
          <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">{{sumNum(items,'applyLeftNum')}}</div>
        </template>
        <template v-slot:foot(planNum)="data">
          <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">{{sumNum(items,'planNum')}}</div>
        </template>
        <template v-slot:foot(amountIncludingTax)="data">
          <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">{{sumNum(items,'amountIncludingTax')}}</div>
        </template>
        <template v-slot:foot(applyNum)="data">
          <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">{{sumNum(items,'applyNum')}}</div>
        </template>
        <template v-slot:foot(feedNum)="data">
          <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">{{sumNum(items,'feedNum')}}</div>
        </template>
        <template v-slot:foot(surplusNum)="data">
          <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">{{sumNum(items,'surplusNum')}}</div>
        </template>
      </b-table>
      <!-- <div>{{items}}</div> -->
    </div>
  </div>
</template>

<script>
import {Decimal} from "decimal.js";
import {BTable} from 'bootstrap-vue'


export default {
  data() {
    return {
      fields: [
        {key: 'index', stickyColumn: true, label: '序号'},
        {key: 'materialData', stickyColumn: true, label: '专业名称/规格/单位'},
        {key: 'materialCommonName', label: '常用名称'},
        {key: 'brandName', label: '品牌'},
      ],
      items: [],
      dataList: [],
      businessId: '',
      searchForm: {
        deratedId: ''
      },
      tablePage: {
        total: 0,
        currentPage: 1,
        pageSize: 5,
        orders: []
      },
      layoutHeight: '0px',
      time: 0
    }
  },
  mounted() {
  },
  created() {
    this.$nextTick(() => {
      this.layoutHeight = document.documentElement.clientHeight - 50 + 'px';
      let query = this.$route.query;
      this.items = query.data.hMaterApplyBillSub
      this.joint(["materialName", "materialModel", "materialUnit"])
      this.items.forEach(i => i.feedNum=i.applyNum - i.surplusNum)
      if(query.data.budgetId != null && query.data.budgetId != 0){
        this.fields.push({ key: 'applyLeftNum',label: '剩余预算数量'},{ key: 'planNum',label: '要料数量'})
        // this.fields.push({ key: 'budgetNum',label: '预算数量'},{ key: 'applyLeftNum',label: '剩余预算数量'})
      }else {
        this.fields.push({ key: 'planNum',label: '要料数量'})
      }
      if( query.data.applyType =='132'){
        this.fields.push({ key: 'priceIncludingTax',label: '含税单价（元）'},{ key: 'amountIncludingTax',label: '含税金额（元）'})
      }
      if(query.data.auditStatus=== '2'){
        this.fields.push({ key: 'applyNum',label: '核准数量'},{ key: 'feedNum',label: '已供料数量'},{ key: 'surplusNum',label: '剩余数量'},{ key: 'useWay',label: '使用部位'},{ key: 'remark',label: '备注'},{ key: 'statusName',label: '要料状态'},)
      }else {
        this.fields.push({ key: 'useWay',label: '使用部位'}, { key: 'remark',label: '备注'})
      }
    });
  },
  methods: {
    init() {
    },
    joint(data) {
      this.items.forEach(i => {
        i.materialData = {}
        data.forEach(key => {
          i.materialData[key] = i[key]
        })
      })
    },
    // 合计计算
    sumNum(arr, key) {
      if (!Array.isArray(arr) || typeof key !== 'string') {
        return 0;
      }
      return arr.reduce((total, item) => {
        if (key in item) {
          const value = Number(item[key]);
          return isNaN(value) ? total : new Decimal(total).add(new Decimal(value)).toFixed(2, Decimal.ROUND_HALF_UP);
        }
        return total;
      }, 0);
    },
    goBack() {
      // document.querySelector('.screenButton').click();
      this.$router.go(-1);
    }
  }
}
</script>

<style>
.mater tr th:nth-child(2),.mater tr td:nth-child(2) {
  left: 30px !important;
}
</style>
